export default {
  set_current_branch (state, branch) {
    state.currentBranch = branch
  },
}
